import { displayErrorDetails } from '@brands/Utils/displayError';
import React from 'react';

import { downloadConversation } from '../../services/communication/downloadConversation';
import styles from './styles.module.scss';

interface IModal {
  setOpenModal: (arg0: boolean) => void;
  conversationSid: string | undefined;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

const DownloadModal = ({ setOpenModal, conversationSid, setLoading }: IModal): JSX.Element => {
  const newDate = new Date().toDateString();

  const getFileName = (): string => `dentistry.one conversation - ${newDate}`;

  const { timeZone } = Intl.DateTimeFormat().resolvedOptions();

  const downloadFunc = async (): Promise<void> => {
    setOpenModal(false);
    setLoading(true);

    try {
      const data = await downloadConversation(conversationSid!, { timezone: timeZone });
      const blob = new Blob([data], { type: 'application/pdf' });
      const blobUrl = URL.createObjectURL(blob);

      // Open PDF in a new tab for all browsers and devices
      const newTab = window.open('', '_blank');
      if (newTab) {
        newTab.location.href = blobUrl;
      } else {
        // Fallback: Force download if new tab is blocked
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = `${getFileName()}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }

      // Cleanup
      setTimeout(() => {
        URL.revokeObjectURL(blobUrl);
      }, 5000);
    } catch (error) {
      displayErrorDetails(`Error downloading the conversation: ${error}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.modalBackground}>
      <div className={styles.modalContainer}>
        <div className={styles.body}>
          <p>Do you want to download this chat?</p>
          <div className={styles.modalButtons}>
            <button
              type="button"
              onClick={() => {
                downloadFunc();
              }}
            >
              Yes
            </button>
            <button
              type="button"
              onClick={() => {
                setOpenModal(false);
              }}
              id="cancelBtn"
            >
              No
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default DownloadModal;
